exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir=ltr] .o30C-0mPu4HVLw3tCQIgs{padding-left:5px}html[dir=rtl] .o30C-0mPu4HVLw3tCQIgs{padding-right:5px}._3HZJJ2h2f162WlHNUMLeqr{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] ._3HZJJ2h2f162WlHNUMLeqr{border-width:1px;border-style:solid;padding:0 4px;background:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir=ltr] ._3HZJJ2h2f162WlHNUMLeqr{left:0}html[dir=rtl] ._3HZJJ2h2f162WlHNUMLeqr{right:0}.q0S8YscBsDIqHYd_faniH{color:\"[theme:themeDark, default:#0D62AA]\";font-weight:600}html[dir=ltr] .IFqNTQnyeNuwl8rrNKX8X{margin-right:-6px}html[dir=rtl] .IFqNTQnyeNuwl8rrNKX8X{margin-left:-6px}", ""]);

// exports
exports.locals = {
	"unreadOrTotalCount": "o30C-0mPu4HVLw3tCQIgs",
	"dragHelperStyle": "_3HZJJ2h2f162WlHNUMLeqr",
	"unreadCount": "q0S8YscBsDIqHYd_faniH",
	"favoriteButton": "IFqNTQnyeNuwl8rrNKX8X"
};